module.exports = __webpack_public_path__ + "img/noninvasive-data-collection@2x.dff84b25.jpg";